'use client'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { clickEvent } from '_libs/common/event-tracker/events'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { Screen } from 'constants/tracking/screens'

type Props = {
  text: string
  url: string
  clickEventTarget?: {
    target: ClickableElement
    targetDetails?: string
    screen?: Screen
  }
  testId?: string
}

const LinkSectionItem = ({ text, url, clickEventTarget, testId }: Props) => {
  const { track } = useTracking()

  return (
    <li className="main-footer__links-section-row">
      <a
        className="main-footer__links-section-link"
        href={url}
        onClick={() => {
          if (!clickEventTarget) {
            return
          }
          track(clickEvent(clickEventTarget))
        }}
        data-testid={testId}
      >
        {text}
      </a>
    </li>
  )
}

export default LinkSectionItem
